export default "__VITE_ASSET__DzTY0qHL__"